export default __webpack_public_path__ + "static/media/tu-sm.f29afa96.svg";